<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { Button } from "@/shadcn/components/ui/button";
import {
  CircleXIcon
} from "@lucide/vue";

const props = defineProps({
  modelValue: {
    type: Array as () => string[],
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
})

const aliases = ref<string[]>([])
onMounted(() => {
  aliases.value = props.modelValue || []
})
watch(
  () => props.modelValue,
  () => { aliases.value = props.modelValue}
)
watch(
  aliases,
  () => { emit('update:modelValue', aliases.value) }
)

const emit = defineEmits<{
  'update:modelValue': [value: string[]]
}>()


const addAlias = () => {
  aliases.value = [...aliases.value, '']
}

const removeAlias = (index: number) => {
  aliases.value.splice(index, 1)
}

const updateAlias = (index: number, value: string) => {
  aliases.value[index] = value
}
</script>

<template>
  <details>
    <summary>{{ $t('Reference aliases') }} ({{ aliases.length }})</summary>
    <div v-for="(alias, index) in aliases" :key="index" class="tw:flex tw:items-center tw:mb-3 tw:gap-2">
      <input
        :name="`${name}[]`"
        type="text"
        :value="alias"
        @input="updateAlias(index, ($event.target as HTMLInputElement).value)"
        class="form-control tw:flex-1"
      />
      <Button
        variant="ghost-destructive"
        type="button"
        @click="removeAlias(index)">
        <CircleXIcon class="tw:size-4"/>
      </Button>
    </div>
    <Button
      variant="link"
      type="button" @click="addAlias">
      {{ $t('Add reference alias') }}
    </Button>
  </details>
</template>